// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Pagination,
  ListGroup,
  FormGroup,
  ControlLabel,
  FormControl,
  Form,
  Button,
  Checkbox,
} from 'react-bootstrap'
import debounce from 'lodash/debounce'
import { browserHistory } from 'react-router'
import queryString from 'query-string'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import * as actions from '../actions'
import { getOpportunites } from '../selectors'
import OpportunityListItem from '../components/OpportunityListItem'
import Loading from '../components/Loading'
import type { OpportunityType } from '../types/OpportunityType'
import Select from 'react-select'
import has from 'lodash/has'
import isEmpty from 'lodash/isEmpty'
import omit from 'lodash/omit'
import keys from 'lodash/keys'

type queryParams = {
  start?: string,
  end?: string,
  search?: string,
  ongoing?: string,
  hidden?: string,
  live?: string,
  deleted?: string,
  hasTags?: string,
  tagsModifiedByOrg?: string,
  tagsModifiedBySubmittable?: string,
  tagsModifiedBySubmittableExceptAutoTag?: string,
  tagsModifiedByAutoTagOnly?: string,
}

const tagFilterOptions = [
  {
    value: 'hasTags',
    label: 'Has Tags',
  },
  {
    value: 'tagsModifiedByOrg',
    label: 'Tags Modified By Org',
  },
  {
    value: 'tagsModifiedBySubmittable',
    label: 'Tags Modified By Submittable',
  },
  {
    value: 'tagsModifiedBySubmittableExceptAutoTag',
    label: 'Tags Modified By Submittable Except Auto Tag',
  },
  {
    value: 'tagsModifiedByAutoTagOnly',
    label: 'Tags Modified By Auto Tag Only',
  },
]

class OpportunitiesPage extends Component {
  fetchFilteredOpportunites: Function
  pushQueryAndFetch: Function
  handleTagFilterChange: Function
  handleTagFilterValue: Function

  props: {
    items: Array<OpportunityType>,
    totalPages: number,
    page: number,
    isFetching: boolean,
    params: {
      page: string,
      id: string,
    },
    fetchOpportunites: Function,
    location: {
      pathname: string,
      query: queryParams,
    },
  }

  constructor(props) {
    super(props)
    this.fetchFilteredOpportunites = debounce(
      this.fetchFilteredOpportunites.bind(this),
      500,
    )
    this.pushQueryAndFetch = this.pushQueryAndFetch.bind(this)
    this.handleTagFilterChange = this.handleTagFilterChange.bind(this)
    this.handleTagFilterValue = this.handleTagFilterValue.bind(this)
  }

  handleTagFilterChange(option) {
    const resetTagFilters = {
      hasTags: false,
      tagsModifiedByOrg: false,
      tagsModifiedBySubmittable: false,
      tagsModifiedBySubmittableExceptAutoTag: false,
      tagsModifiedByAutoTagOnly: false,
    }
    if (option) {
      this.pushQueryAndFetch(
        {
          ...resetTagFilters,
          [option.value]: true,
        },
        '1',
        keys(resetTagFilters).filter(item => item !== option.value),
      )
    } else {
      //when select is cleared there is no option
      this.pushQueryAndFetch(resetTagFilters)
    }
  }

  handleTagFilterValue() {
    const selected = tagFilterOptions.find(
      item =>
        has(this.props.location.query, item.value) &&
        this.props.location.query[item.value] === 'true',
    )
    return selected ? selected.value : null
  }

  fetchFilteredOpportunites(
    query: queryParams = this.props.location.query,
    page: string = this.props.params.page,
  ) {
    this.props.fetchOpportunites({ page, ...query })
  }

  componentWillMount() {
    this.fetchFilteredOpportunites()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.params.page !== this.props.params.page) {
      this.fetchFilteredOpportunites()
    }
  }

  pushQueryAndFetch(
    query: queryParams = {},
    page: string = '1',
    omitProps = ['propNames'],
  ) {
    let newquery = {
      ...this.props.location.query,
      ...query,
    }
    newquery = omit(newquery, omitProps)

    browserHistory.push({
      pathname: `/opportunities/${page}`,
      query: newquery,
    })
    this.fetchFilteredOpportunites(newquery, page)
  }

  clearFilters() {
    browserHistory.push({
      pathname: this.props.location.pathname,
    })
    this.fetchFilteredOpportunites()
  }

  render() {
    const { items, totalPages, page, isFetching, params, location } = this.props
    const {
      start,
      end,
      search = '',
      ongoing,
      hidden,
      live,
      deleted,
    } = location.query
    return (
      <div>
        <Form
          inline
          style={{ marginBottom: 20 }}
          onSubmit={event => event.preventDefault()}
        >
          <Row>
            <Col xs={12} md={12}>
              <h3>Opportunites & Categories</h3>
              <FormGroup controlId="searchOpp">
                <ControlLabel>Search</ControlLabel>
                {' '}
                <FormControl
                  type="text"
                  value={search}
                  style={{ minWidth: '350px' }}
                  placeholder="Enter text"
                  onChange={event =>
                    this.pushQueryAndFetch({
                      search: event.target.value,
                    })}
                />
              </FormGroup>
              {' '}
              <FormGroup controlId="startDate">
                <ControlLabel>Start</ControlLabel>
                {' '}
                <DatePicker
                  className="form-control"
                  name="startDate"
                  selectsStart
                  selected={start ? moment(start) : null}
                  startDate={start ? moment(start) : null}
                  endDate={end ? moment(end) : null}
                  onChange={momentDate => {
                    this.pushQueryAndFetch({
                      start: momentDate ? momentDate.format() : '',
                    })
                  }}
                  placeholderText="Date"
                />
              </FormGroup>
              {' '}
              <ControlLabel>End</ControlLabel>
              {' '}
              <DatePicker
                className="form-control"
                name="endDate"
                selectsEnd
                selected={end ? moment(end) : null}
                startDate={start ? moment(start) : null}
                endDate={end ? moment(end) : null}
                onChange={momentDate => {
                  this.pushQueryAndFetch({
                    end: momentDate ? momentDate.format() : '',
                  })
                }}
                placeholderText="Date"
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={2} md={2}>
              <ControlLabel>Opportunity Status:</ControlLabel>
              {' '}
            </Col>
            <Col xs={2} md={2}>
              <Checkbox
                title="On-going"
                checked={ongoing === 'true'}
                onChange={ongoing => {
                  this.pushQueryAndFetch({
                    ongoing: ongoing.target.checked,
                  })
                }}
              >
                {' '}On-going
              </Checkbox>
            </Col>
            <Col xs={2} md={2}>
              <Checkbox
                title="Hidden"
                checked={hidden === 'true'}
                onChange={hidden => {
                  this.pushQueryAndFetch({
                    hidden: hidden.target.checked,
                  })
                }}
              >
                {' '} Hidden
              </Checkbox>
            </Col>
            <Col xs={2} md={2}>
              <Checkbox
                title="live"
                checked={live === 'true'}
                onChange={live => {
                  this.pushQueryAndFetch({
                    live: live.target.checked,
                  })
                }}
              >
                {' '}Live
              </Checkbox>
            </Col>
            <Col xs={2} md={2}>
              <Checkbox
                title="Deleted"
                checked={deleted === 'true'}
                onChange={deleted => {
                  this.pushQueryAndFetch({
                    deleted: deleted.target.checked,
                  })
                }}
              >
                {' '}Deleted
              </Checkbox>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={12} md={2}>
              <ControlLabel>Tag Status:</ControlLabel>
            </Col>
            <Col xs={12} md={5}>
              {' '}
              <Select
                name="tagModifications"
                style={{ maxWidth: '350px' }}
                placeholder="Select tag status"
                valueKey="value"
                options={tagFilterOptions}
                onChange={this.handleTagFilterChange}
                value={this.handleTagFilterValue()}
              />
            </Col>
            <Col xs={12} md={5}>
              {!isEmpty(location.query)
                ? <Button
                    className="pull-right"
                    onClick={() => {
                      this.clearFilters()
                    }}
                    bsStyle="warning"
                  >
                    Clear filters
                  </Button>
                : null}
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              {' '}

              {isFetching
                ? <Loading />
                : <ListGroup componentClass="ul">
                    {items.map(item => (
                      <OpportunityListItem
                        key={item.id}
                        item={item}
                        queryString
                        to={`/opportunities/${page}/${item.id}/?${queryString.stringify(location.query)}`}
                        isOpen={Number(params.id) === item.id}
                      />
                    ))}
                  </ListGroup>}
              {!isFetching && !items.length
                ? <h5>No opportunites found</h5>
                : null}
              {totalPages > 1
                ? <div className="text-center">
                    <Pagination
                      prev
                      next
                      first
                      last
                      ellipsis
                      boundaryLinks
                      items={totalPages}
                      maxButtons={10}
                      activePage={page}
                      onSelect={newPage => {
                        this.pushQueryAndFetch({}, newPage)
                      }}
                    />
                  </div>
                : null}
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  ...getOpportunites(state),
})

export default connect(mapStateToProps, actions)(OpportunitiesPage)



// WEBPACK FOOTER //
// ./src/pages/OpportunitiesPage.js